import { FloraButton } from '@grupoboticario/flora-react';
import { ShoppingCartPlusIcon } from '@grupoboticario/flora-react-icons';
import { QuantitySelector } from 'ui/components';

import type { AvailableButtonProps } from './Product.components.d';

export const AvailableButton = ({
  disabled = false,
  onAddProduct,
  onChangeAmount,
  productCode,
  productOrigin,
  productPosition,
  quantity,
  itemListName,
  name,
  ...props
}: AvailableButtonProps) => {
  const handleAddProduct = () => {
    onAddProduct(productCode, itemListName);
  };

  const handleQuantityChange = (amount: AvailableButtonProps['quantity']) => {
    onChangeAmount({ productCode, productOrigin, productPosition, quantity: amount, itemListName });
  };

  if (quantity === 0) {
    return (
      <FloraButton
        onClick={handleAddProduct}
        isFull
        data-testid="available-button-add"
        disabled={disabled}
        tabIndex={0}
        aria-label={`adicionar ${name} ao carrinho`}
        data-flora="button"
        data-flora-text="Ver similares"
        icon={<ShoppingCartPlusIcon size={24} />}
        {...props}
      >
        Adicionar
      </FloraButton>
    );
  }

  return (
    <QuantitySelector
      onChange={handleQuantityChange}
      value={quantity}
      disabled={disabled}
      data-testid="available-button-quantity-selector"
      name={name}
      {...props}
    />
  );
};
